// extracted by mini-css-extract-plugin
export default {"block_subtitle":"adminKnowledgeBaseTestsPage_block_subtitle__exkyC","block":"adminKnowledgeBaseTestsPage_block__t3u02","test":"adminKnowledgeBaseTestsPage_test__4D0F0"};